/* eslint-disable @typescript-eslint/no-explicit-any */

export function sanitizeReduxActionForLog(action: any) {
  return sanitizeObjectForLogWithWhiteList(action, ['type'], undefined)
}

export function sanitizeErrorForLog(error: any) {
  // TODO: Review TrackJS traces
  return error
}

/**
 * sanitizeObjectForLogWithBlackList removes any key value from an object using a black list, in a recursive way
 * Based on https://www.bennadel.com/blog/3278-using-json-stringify-replacer-function-to-recursively-serialize-and-sanitize-log-data.htm
 */
export function sanitizeObjectForLogWithBlackList(objectToSanitize: any, blackList: string[], sanitizedValue: any) {
  const jsonReplacer = buildJsonReplacerBlackList(
    blackList.map((entry) => entry.toLowerCase()),
    sanitizedValue
  )
  const sanitized = JSON.stringify(objectToSanitize, jsonReplacer)
  return JSON.parse(sanitized)
}

function buildJsonReplacerBlackList(blackList: string[], sanitizedValue: string | undefined) {
  return function (key: any, value: any) {
    if (value instanceof Error) {
      return preserveErrorProperties(value)
    } else if (key && blackList.includes(key.toLowerCase())) {
      return sanitizedValue
    } else {
      return value
    }
  }
}

function preserveErrorProperties(error: Error) {
  const copy = Object.assign({}, error)

  error.name && (copy.name = error.name)
  error.message && (copy.message = error.message)
  error.stack && (copy.stack = error.stack)

  return copy
}

/**
 * sanitizeObjectForLogWithWhiteList keeps just the prop included in the whitelist, in a recursive way
 */
export function sanitizeObjectForLogWithWhiteList(objectToSanitize: any, whiteList: string[], sanitizedValue: any) {
  const jsonReplacer = buildJsonReplacerWhiteList(
    whiteList.map((entry) => entry.toLowerCase()),
    sanitizedValue
  )
  const sanitized = JSON.stringify(objectToSanitize, jsonReplacer)
  return JSON.parse(sanitized)
}

function buildJsonReplacerWhiteList(whiteList: string[], sanitizedValue: string | undefined) {
  return function (key: any, value: any) {
    if (value instanceof Error) {
      return preserveErrorProperties(value)
    } else if (key && !whiteList.includes(key.toLowerCase())) {
      return sanitizedValue
    } else {
      return value
    }
  }
}
